/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './IaReport.css';

import aspas from '../../../../assets/images/aspas.svg';
import FilterData from '../../../../components/FilterAnalyze/FilterData/FilterData';

import { IaReportAction } from '../../../../store/actions/iaReports';

function NotUnderstood() {
  const [refGraphic, setRefGraphic] = useState(useRef(null));
  const { getNotUnderstoodIntentions } = IaReportAction;

  const [reportData, setReportData] = useState([]);

  const dispatch = useDispatch();

  const botState = useSelector((state) => state.bots.bot);
  const iaReportState = useSelector(
    (state) => state.iaReports.notUnderstoodReports
  );
  const filtersState = useSelector((state) => state.filter);
  const timezone = useSelector((state) => state.bots.bot.settings.timezone);

  const onClickFilter = () => {
    const payload = {
      botId: botState._id,
      startDate: filtersState.startDate,
      endDate: filtersState.endDate,
      tags: filtersState.nameTags,
      channels: filtersState.channels,
      variables: filtersState.variables,
      timezone: timezone.fuso,
    };

    dispatch(getNotUnderstoodIntentions(payload));
  };

  useEffect(() => {
    if (botState && filtersState) {
      onClickFilter();
    }
  }, []);

  useEffect(() => {
    setReportData(iaReportState);
  }, [iaReportState]);

  const getUnderBarClassName = useCallback(
    (index) => {
      const twentyFivePercentPart =
        reportData && Math.round(reportData.length / 4);

      const firstInterval = index === 0 || index < twentyFivePercentPart;

      const secondInterval =
        index >= twentyFivePercentPart && index < twentyFivePercentPart * 2;

      const thirtyInterval =
        index >= twentyFivePercentPart && index < twentyFivePercentPart * 3;

      const fourInterval = index > twentyFivePercentPart * 3;

      if (firstInterval) return 'under__most-frequently-1';
      if (secondInterval) return 'under__most-frequently-2';
      if (thirtyInterval) return 'under__most-frequently-3';
      if (fourInterval) return '';
    },
    [reportData]
  );

  return (
    <div>
      <FilterData
        onClickFilter={onClickFilter}
        graphicReference={refGraphic}
        graphicName="not-understood"
        showDownload
        showMoreFilters
      />

      <div className="container-retangulo-ia">
        <div className="header-retangulo-ia">
          <img src={aspas} alt="aspas" />
          <p>Não entendidas</p>
        </div>
        <div className="subtitle-body-retangulo-ia">
          {reportData.length <= 0 && <strong>Nenhum dado encontrado</strong>}
          {reportData.length > 0 && (
            <>
              <p>Freq.</p>
              <p>Expressão</p>
            </>
          )}
        </div>
        <div className="body-retangulo-ia" ref={(e) => setRefGraphic(e)}>
          {reportData.map((par, index) => (
            <div
              className={`container-body-retangulo ${getUnderBarClassName(
                index
              )}`}
            >
              <div className="barra-freq">
                <p>{par.number}</p>
              </div>
              <div className="barra-expressao">{par.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default NotUnderstood;
